import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import AiChatInput from '../common/search/aiChatInput';
const AiChatModal = ({
  isOpen,
  onToggle,
  onSendMessage,
  onClear,
  waitingMessage,
  emptyStateMessage,
  messages: _messages = [],
  isLoading: _isLoading = false,
  label: _label = /*#__PURE__*/React.createElement("span", null, "AI Chat Assistant"),
  placeholder: _placeholder = 'Ask me anything...',
  text: _text = ''
}) => {
  const handleToggle = () => {
    if (!_isLoading) onToggle();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: handleToggle,
    size: "xl",
    "data-testid": "t-cf-ai-chat-modal",
    style: {
      maxWidth: '800px'
    },
    backdrop: _isLoading ? 'static' : true,
    keyboard: !_isLoading
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: handleToggle
  }, _label), /*#__PURE__*/React.createElement(ModalBody, {
    className: "p-0"
  }, /*#__PURE__*/React.createElement(AiChatInput, {
    className: "t-cf-ai-chat",
    messages: _messages,
    onSendMessage: onSendMessage,
    onClear: onClear,
    placeholder: _placeholder,
    isLoading: _isLoading,
    text: _text,
    waitingMessage: waitingMessage,
    emptyStateMessage: emptyStateMessage
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: handleToggle,
    disabled: _isLoading
  }, "Close")));
};
AiChatModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSendMessage: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['user', 'assistant', 'system']).isRequired,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  isLoading: PropTypes.bool,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  text: PropTypes.string,
  waitingMessage: PropTypes.string.isRequired,
  emptyStateMessage: PropTypes.string.isRequired
};
export default AiChatModal;